import * as React from 'react';

import { DialogContext } from './context';

export default function useDialog() {
  const context = React.useContext(DialogContext);

  return { openDialog: context.openDialog, closeDialog: context.closeDialog };
}
